import { z } from 'zod';
import { NotAuthorizedClient } from '~/app-modules/core/clients/not-authorized-client';
import { HttpConnection } from '~/app-modules/core/clients/http-connection';
import { TGetAccessTokenRequestDto } from '~/app-modules/auth/clients/dto/get-access-token-request-dto';
import { TRefreshAuthTokenRequestDto } from '~/app-modules/auth/clients/dto/refresh-auth-token-request-dto';
import { GetAccessTokenResponseDto } from '~/app-modules/auth/clients/dto/get-access-token-response-dto';

@singleton()
export class AuthClient extends NotAuthorizedClient {
  constructor(connection: HttpConnection) {
    super(connection);
  }

  async getSignInUrl() {
    return await this.executeRequest(
      {
        method: 'get',
        url: '/ui/v1/auth/sign-in-url',
      },
      z.string(),
    );
  }

  async signIn(request: TGetAccessTokenRequestDto) {
    return await this.executeRequest(
      {
        method: 'post',
        url: '/ui/v1/auth/sign-in',
        data: request,
      },
      GetAccessTokenResponseDto,
    );
  }

  async refreshToken(request: TRefreshAuthTokenRequestDto) {
    return await this.executeRequest(
      {
        method: 'post',
        url: '/ui/v1/auth/token',
        data: request,
      },
      GetAccessTokenResponseDto,
    );
  }
}
